"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSERVER_ENDPOINTS = exports.WEBSERVER_URL = void 0;
exports.WEBSERVER_URL = {
    production: 'https://backend.fractalprotocol.org',
    development: 'https://backend-dev.augustdigital.io',
    localhost: 'http://127.0.0.1:8000',
    qa: 'https://backend-qa.augustdigital.io',
};
exports.WEBSERVER_ENDPOINTS = {
    default: {
        hello: '/hello',
        protected: '/protected',
    },
    auth: {
        verify: '/auth/secret',
        sign: '/auth/sign',
        login: '/auth/login',
        nonce: '/auth/nonce',
        refresh: '/auth/refresh',
    },
    subaccount: {
        rewards: (subaccount) => `/subaccount/${subaccount}/rewards`,
        tokens: (subaccount) => `/subaccount/${subaccount}/tokens`,
        twap: {
            create: (subaccount) => `/subaccount/${subaccount}/twap`,
            stop: (subaccount, id) => `/subaccount/${subaccount}/twap/${id}/stop`,
            fills: (subaccount, id) => `/subaccount/${subaccount}/twap/${id}/fills`,
        },
    },
    users: {
        get: '/users',
    },
    prices: (symbol) => `/prices/${symbol}`,
};
//# sourceMappingURL=august.js.map